import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  Image,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  SimpleGrid,
  Text,
  VStack,
  keyframes,
  useDisclosure,
} from "@chakra-ui/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaBeer,
  FaInstagram,
  FaMapMarkerAlt,
  FaPercentage,
} from "react-icons/fa";
import {
  RiCloseCircleLine,
  RiHome5Line,
  RiLoginBoxLine,
  RiLogoutBoxLine,
  RiMenu2Fill,
  RiQuestionLine,
  RiRecordCircleLine,
  RiSearchLine,
  RiShoppingBasket2Line,
  RiStarLine,
  RiTruckLine,
  RiUser3Line,
  RiVipCrown2Line,
  RiShoppingBag3Line,
  RiStore2Line,
  RiStarSmileLine,
  RiInformationLine,
  RiInstagramLine,
  RiGridFill
} from "react-icons/ri";

import { theme } from "../../styles/theme";
import { AuthContext } from "../../Context/AuthContext";
import { CityContext } from "../../Context/CityContext";
import { CartContext } from "../../Context/CartContext";
import { Search } from "../Search";
import { CartComponent } from "../CartComponent";
import { api } from "../../services/api";

import logoWhiteOrange from "../../assets/images/logo-white-orange.webp";
import newLogo from "../../assets/images/new-logo.webp";
import logoOrangeGreen from "../../assets/images/logo-white-bg.webp";


const slideLeft = keyframes`
  0% { transform: translateX(100%); opacity: 0; }
  100% { transform: translateX(0%); opacity: 1; }
`;

const Navbar = () => {
  const { user, signOutUser, isAuthenticated } = useContext(AuthContext);
  const { cityName, fetchCEP } = useContext(CityContext);
  const { cartItemsCounter } = useContext(CartContext);

  const navigate = useNavigate();
  const location = useLocation();
  const inputRef = useRef(null);

  const [cep, setCep] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);

  const menuDrawer = useDisclosure();
  const cartDrawer = useDisclosure();

  const isHomePage = location.pathname === "/";

  const primaryGreen = theme.colors.primaryGreen;
  const primaryOrange = theme.colors.primaryOrange;

  const city = cityName && cityName.trim().length > 0
  ? cityName
  : "Belo Horizonte";

  const promoItems = [
    {
      text: "Maior loja de drinks prontos do Brasil",
      icon: <RiVipCrown2Line />,
    },
    {
      text: "Maior variedade de chopes de BH, com o menor preço do mercado",
      icon: <FaBeer />,
    },
    {
      text: "GANHE 5% de desconto em sua primeira compra",
      icon: <FaPercentage />,
    },
    {
      text: "Frete grátis acima de R$120,00",
      icon: <RiTruckLine />,
    },
  ];

  const linksCategories = [
    {
      title: "Camisas/Acessórios",
      params: JSON.stringify(["Acessórios"]),
    },
    {
      title: "Kits",
      params: JSON.stringify(["Kits"]),
    },
    {
      title: "Drinks Prontos",
      params: JSON.stringify(["OUTRAS BEBIDAS", "BEBIDAS MISTAS"]),
    },
  ];

  const typeFilters = [
    { cardTitle: "Chopp", param: JSON.stringify(["chopp", "Chopp"]) },
    {
      cardTitle: "Drinks Prontos",
      param: JSON.stringify(["OUTRAS BEBIDAS", "BEBIDAS MISTAS"]),
    },
    {
      cardTitle: "Microcervejarias",
      param: JSON.stringify([
        "Microcervejarias",
        "microcervejarias",
        "microcervejaria",
        "Microcervejaria",
      ]),
    },
    { cardTitle: "Cervejas", param: JSON.stringify(["CERVEJA", "Cerveja"]) },
    { cardTitle: "Vinhos", param: JSON.stringify(["Vinho"]) },
    { cardTitle: "Destilados", param: JSON.stringify(["DESTILADOS"]) },
    {
      cardTitle: "Eventos",
      param: JSON.stringify(["Eventos, Buffets e Casamentos"]),
    },
    { cardTitle: "KITS", param: JSON.stringify(["Kits"]) },
    {
      cardTitle: "Não Alcoólicos",
      param: JSON.stringify([
        "NÃO ALCOOLICOS",
        "Não alcoólicos",
        "Não Alcoólicos",
        "NÃO ALCOOLICO",
        "Não alcóolico",
        "Não Alcóolico",
      ]),
    },
    { cardTitle: "Acessórios", param: JSON.stringify(["Acessórios"]) },
    {
      cardTitle: "Projetos Sociais",
      param: JSON.stringify([
        "Projetos Sociais",
        "projetos sociais",
        "Projetos sociais",
      ]),
    },
    { cardTitle: "Mais Vendidos", param: JSON.stringify(["Mais Vendidos"]) },
    { cardTitle: "Maiores Descontos", param: JSON.stringify(["Maiores Descontos"]) },

  ];

  // const typesOfCardToSelect = typeFilters.filter((card) => {
  //   const fullCities = [
  //     "Belo Horizonte",
  //     "Nova Lima",
  //     "Contagem",
  //     "Betim",
  //     "Lagoa Santa",
  //   ];

  //   // if (fullCities.includes(cityName)) return true;
  //   if (!cityName || fullCities.includes(cityName)) {
  //     return true;
  //   }

  //   return (
  //     card.cardTitle === "Drinks Prontos" ||
  //     card.cardTitle === "Maiores Descontos" ||
  //     card.cardTitle === "Mais Vendidos"
  //   );
  // });

  const typesOfCardToSelect = typeFilters;

  useEffect(() => {
    isAuthenticated();
  }, [user]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % promoItems.length);
    }, 3000);

    return () => clearInterval(intervalId);
  }, [promoItems.length]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setShowInput(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const userPhoto =
    localStorage.getItem("userPhoto") ||
    "https://img.freepik.com/free-icon/user_318-159711.jpg";

  const handleSubmitCep = (e) => {
    e.preventDefault();

    if (cep) {
      fetchCEP(cep);
      setShowInput(false);
    }
  };

  const handleBestSellings = async () => {
    try {
      const filter = JSON.stringify(["Mais Vendidos"]);
      const url = `/api/v1/products?&filter=${filter}&city_name=${city}`;
      const response = await api.get(url);

      navigate(
        `/produtos?&filter=${encodeURIComponent(filter)}&city_name=${city}`,
        { state: { products: response.data.products } }
      );

      menuDrawer.onClose();
    } catch (error) {
      console.error(error);
    }
  };

  const handleScrollToStore = () => {
    if (isHomePage) {
      const el = document.getElementById("storeSection");
      if (el) window.scrollTo({ top: el.offsetTop - 160, behavior: "smooth" });
    } else {
      navigate("/#store");
    }
    menuDrawer.onClose();
  };

  const logoToUse =
  isScrolled
    ? logoWhiteOrange // mesma logo para todas quando scrollar
    : isHomePage
      ? logoWhiteOrange // home sem scroll
      : logoOrangeGreen; // demais páginas sem scroll

  const LocationSelector = ({ compact = false }) => (
    <Box ref={inputRef}>
      {!showInput ? (
        <Button
          bg="transparent"
          color={primaryOrange}
          fontSize={compact ? "12px" : "14px"}
          fontWeight="800"
          h="auto"
          minH="auto"
          p="0"
          leftIcon={<FaMapMarkerAlt />}
          _hover={{ bg: "transparent", opacity: 0.85 }}
        >
          {cityName || "Belo Horizonte"}
        </Button>
      ) : (
        <Box
          as="form"
          onSubmit={handleSubmitCep}
          position="relative"
          w={compact ? "170px" : "220px"}
        >
          <Input
            placeholder="Digite o CEP"
            value={cep}
            onChange={(e) => setCep(e.target.value)}
            bg="white"
            color="black"
            borderRadius="999px"
            h="34px"
            pr="42px"
            border={`1px solid ${primaryOrange}`}
            _focus={{ boxShadow: `0 0 0 1px ${primaryOrange}` }}
          />

          <IconButton
            type="submit"
            aria-label="Buscar CEP"
            icon={<RiSearchLine />}
            position="absolute"
            right="2px"
            top="2px"
            h="30px"
            minW="34px"
            borderRadius="999px"
            bg={primaryOrange}
            color={primaryGreen}
            _hover={{ bg: primaryOrange, opacity: 0.9 }}
          />
        </Box>
      )}
    </Box>
  );

  const UserMenu = ({ showOnMobile = false }) => (
    <Menu>
      <MenuButton
        as={IconButton}
        display={{
          base: showOnMobile ? "inline-flex" : "none",
          md: "inline-flex",
        }}
        aria-label="Menu do usuário"
        icon={
          user ? (
            <Avatar
              size="sm"
              border={`2px solid ${primaryOrange}`}
              src={userPhoto}
            />
          ) : (
            <RiUser3Line size="28px" />
          )
        }
        bg="transparent"
        color={primaryOrange}
        _hover={{ bg: "whiteAlpha.200" }}
      />

      <MenuList zIndex="10000" borderColor={primaryOrange}>
        {user?.access === "admin" && (
          <MenuItem as={Link} to="/admin/dashboard" fontWeight="700">
            Painel do Admin
          </MenuItem>
        )}

        {user ? (
          <>
            <MenuItem as={Link} to={`/perfil/${user.id}`} fontWeight="700">
              Perfil
            </MenuItem>

            <MenuItem onClick={signOutUser} fontWeight="700">
              Sair
            </MenuItem>
          </>
        ) : (
          <>
            <MenuItem as={Link} to="/sign_in" fontWeight="700">
              Entrar
            </MenuItem>

            <MenuItem as={Link} to="/sign_up" fontWeight="700">
              Cadastrar
            </MenuItem>
          </>
        )}
      </MenuList>
    </Menu>
  );

  const MenuItem = ({
    icon,
    children,
    ...props
  }) => (
    <Button
      variant="ghost"
      justifyContent="flex-start"
      leftIcon={icon}
      h="52px"
      mx={0}
      borderRadius="14px"
      color={primaryGreen}
      fontWeight="700"
      _hover={{
        bg: "orange.50",
        color: primaryOrange,
        transform: "translateX(4px)"
      }}
      {...props}
    >
      {children}
    </Button>
  );

  const CartButton = ({ mobile = false }) => (
    <IconButton
      aria-label="Abrir carrinho"
      onClick={cartDrawer.onOpen}
      icon={
        <Box position="relative" display="inline-flex" alignItems="center" justifyContent="center">
          <Badge
            position="absolute"
            top="-15px"
            right="5px"
            bg={primaryOrange}
            color={primaryGreen}
            borderRadius="999px"
            minW="18px"
            h="18px"
            fontSize="12px"
            fontWeight="900"
            display="flex"
            alignItems="center"
            justifyContent="center"
            zIndex="2"
          >
            {cartItemsCounter}
          </Badge>

          <RiShoppingBasket2Line size={mobile ? "30px" : "30px"} />
        </Box>
      }
      bg="transparent"
      color={primaryOrange}
      _hover={{ bg: "whiteAlpha.200" }}
    />
  );

  const CategoryModal = () =>
    isCategoryModalOpen && (
      <Box
        position="fixed"
        inset="0"
        bg="blackAlpha.600"
        display="flex"
        justifyContent="center"
        alignItems="center"
        zIndex="100000"
        px="16px"
      >
        <Box
          bg="white"
          borderRadius="24px"
          boxShadow="2xl"
          p={{ base: 4, md: 6 }}
          width={{ base: "100%", md: "680px" }}
          maxH="85vh"
          overflowY="auto"
        >
          <Flex justify="space-between" align="center" mb="16px">
            <Box>
              <Text fontSize="xl" fontWeight="900" color={primaryGreen}>
                Escolha o tipo
              </Text>
              <Text fontSize="sm" color="gray.500">
                Navegue pelas categorias disponíveis para sua região.
              </Text>
            </Box>

            <IconButton
              aria-label="Fechar"
              icon={<RiCloseCircleLine />}
              bg="transparent"
              color={primaryOrange}
              fontSize="24px"
              onClick={() => setIsCategoryModalOpen(false)}
              _hover={{ bg: "orange.50" }}
            />
          </Flex>

          <Divider mb="18px" />

          <SimpleGrid columns={{ base: 2, md: 3 }} spacing={3}>
            {typesOfCardToSelect.map((filter, index) => (
              <Button
                as={Link}
                to={`/produtos?filter=${encodeURIComponent(
                  filter.param
                )}&city_name=${cityName}`}
                key={index}
                onClick={() => setIsCategoryModalOpen(false)}
                border={`1px solid ${primaryGreen}`}
                color={primaryOrange}
                borderRadius="999px"
                bg={primaryGreen}
                fontSize="sm"
                fontWeight="800"
                whiteSpace="normal"
                h="44px"
                _hover={{
                  bg: primaryOrange,
                  color: primaryGreen,
                }}
              >
                {filter.cardTitle}
              </Button>
            ))}
          </SimpleGrid>
        </Box>
      </Box>
    );

  return (
    <>
      <Box
        id="boozen-navbar"
        position="fixed"
        top={0}
        left={0}
        right={0}
        zIndex="1000"
        transition="all .25s ease"
      >
        {isHomePage && !isScrolled && (
          <Flex
            bg={primaryGreen}
            color={primaryOrange}
            minH="38px"
            align="center"
            justify="center"
            overflow="hidden"
            px="16px"
            m="0"
            p="0"
            mb="0"
          >
            <HStack
              key={currentIndex}
              animation={`${slideLeft} .45s ease`}
              spacing="8px"
              fontWeight="800"
              fontSize={{ base: "12px", md: "14px" }}
              textAlign="center"
            >
              <Box>{promoItems[currentIndex].icon}</Box>
              <Text>{promoItems[currentIndex].text}</Text>
            </HStack>
          </Flex>
        )}

        <Box
          bg={isScrolled ? primaryGreen : "transparent"}
          backdropFilter={isScrolled ? "blur(12px)" : "none"}
          borderBottom={isScrolled ? "1px solid rgba(255,255,255,.12)" : "none"}
          boxShadow={isScrolled ? "0 12px 35px rgba(0,0,0,.16)" : "none"}
          transition="all .25s ease"
          px={{ base: 3, md: 8 }}
          py={{ base: isHomePage && !isScrolled ? "0px" : 2, md: isScrolled ? 3 : 4 }}
          overflow="visible"
          m="0"
          mt="-4px"
        >
          <Flex
            align="center"
            justify="space-between"
            position="relative"
            width="100%"
            minH={{
              base: isHomePage && !isScrolled ? "64px" : "72px",
              md: isScrolled ? "64px" : "80px"
            }}
            overflow="visible"
          >
            <HStack
              spacing={3}
              width={{ base: "135px", md: "360px" }}
              justify="flex-start"
              zIndex="3"
            >
              <IconButton
                aria-label="Abrir menu"
                icon={<RiMenu2Fill size="30px" />}
                onClick={menuDrawer.onOpen}
                bg="transparent"
                color={primaryOrange}
                _hover={{
                  background: "rgba(0, 74, 51, .72)",
                  color: primaryOrange,
                }}
              />

              <Box display={{ base: "none", md: "block" }}>
                <LocationSelector />
              </Box>
            </HStack>

            <Box
              position="absolute"
              left="50%"
              top="50%"
              transform="translate(-50%, -50%)"
              zIndex="2"
              textAlign="center"
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              maxH="100%"
              overflow="visible"
            >
              <Link to="/">
                <Image
                  mx="auto"
                  maxW={{ base: "110px", md: isScrolled ? "135px" : "155px" }}
                  maxH="100%"
                  objectFit="contain"
                  transition="all .25s ease"
                  src={logoToUse}
                />
              </Link>

              <Box display={{ base: "block", md: "none" }} mt="2px">
                <LocationSelector compact />
              </Box>
            </Box>

            <HStack
              spacing={{ base: 1, md: 3 }}
              width={{ base: "135px", md: "520px" }}
              justify="flex-end"
              zIndex="3"
            >
              <Button
                display={{ base: "none", md: "inline-flex" }}
                onClick={() => setIsCategoryModalOpen(true)}
                leftIcon={<FaBeer />}
                bg="whiteAlpha.100"
                color={primaryOrange}
                border={`1px solid rgba(239, 146, 7, .35)`}
                borderRadius="999px"
                fontWeight="900"
                padding="0.3rem"
                _hover={{
                  background: "rgba(0, 74, 51, .72)",
                  color: primaryOrange,
                  borderColor: primaryOrange,
                }}
              >
                Categorias
              </Button>

              <Box display={{ base: "none", md: "block" }} minW="290px">
                <Search />
              </Box>

              <UserMenu />
              <CartButton />
            </HStack>
          </Flex>

          <Flex
            display={{ base: "none", md: "flex" }}
            mt={isScrolled ? 3 : 4}
            align="center"
            justify="center"
            gap={2}
          >
            {linksCategories.map((card, index) => (
              <Button
                key={index}
                as={Link}
                to={`/produtos?filter=${encodeURIComponent(card.params)}`}
                variant="ghost"
                color={primaryOrange}
                fontWeight="900"
                fontSize="sm"
                borderRadius="999px"
                _hover={{
                  background: "rgba(0, 74, 51, .72)",
                  color: primaryOrange,
                }}
              >
                {card.title}
              </Button>
            ))}

            <Button
              onClick={handleScrollToStore}
              variant="ghost"
              color={primaryOrange}
              fontWeight="900"
              fontSize="sm"
              borderRadius="999px"
              _hover={{
                background: "rgba(0, 74, 51, .72)",
                color: primaryOrange,
              }}
            >
              BEBIDAS
            </Button>

            <Button
              as={Link}
              to="/quem_somos"
              variant="ghost"
              color={primaryOrange}
              fontWeight="900"
              fontSize="sm"
              borderRadius="999px"
              _hover={{
                background: "rgba(0, 74, 51, .72)",
                color: primaryOrange,
              }}
            >
              QUEM SOMOS
            </Button>

            <Button
              onClick={handleBestSellings}
              variant="ghost"
              color={primaryOrange}
              fontWeight="900"
              fontSize="sm"
              borderRadius="999px"
              _hover={{
                background: "rgba(0, 74, 51, .72)",
                color: primaryOrange,
              }}
            >
              DESTAQUES
            </Button>
          </Flex>

          <Box display={{ base: isScrolled ? "block" : "none", md: "none" }} mt={2}>
            <Search />
          </Box>
        </Box>
      </Box>

      <Box
        h={{
          base: isScrolled ? "86px" : (isHomePage ? "0px" : "0px"),
          md: isScrolled ? "105px" : (isHomePage ? "0px" : "0px"),
        }}
      />

      <CategoryModal />

      <Drawer placement="left" onClose={menuDrawer.onClose} isOpen={menuDrawer.isOpen}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader
            bg={`
              linear-gradient(
                135deg,
                ${primaryGreen} 0%,
                #00553b 100%
              )
            `}
            color="white"
            py={6}
          >
            <DrawerCloseButton color="white" />

            <Flex align="center" gap={4}>
              <Avatar
                size="md"
                src={userPhoto}
                border="3px solid"
                borderColor={primaryOrange}
              />

              <Box>
                <Text
                  fontWeight="900"
                  fontSize="lg"
                >
                  {user ? user.full_name : "Bem-vindo"}
                </Text>

                <Text
                  fontSize="sm"
                  opacity={0.8}
                >
                  {user ? user.email : "Boozen Marketplace"}
                </Text>
              </Box>
            </Flex>
          </DrawerHeader>

          <DrawerBody px={0} py={4}>
            <Text
              px={5}
              pt={2}
              pb={1}
              fontSize="11px"
              fontWeight="800"
              color="gray.500"
              textTransform="uppercase"
              letterSpacing="1px"
            >
              Minha Conta
            </Text>
            <VStack align="stretch" spacing={1}>
              {user?.access === "admin" && (
                <Button
                  as={Link}
                  to="/admin/dashboard"
                  onClick={menuDrawer.onClose}
                  justifyContent="flex-start"
                  leftIcon={<RiVipCrown2Line />}
                  bg="transparent"
                  color={primaryOrange}
                  fontWeight="900"
                  borderRadius="0"
                  px={5}
                  _hover={{ bg: "orange.50", color: primaryGreen }}
                >
                  Painel do Admin
                </Button>
              )}

              {user && (<>
                <MenuItem
                  as={Link}
                  to={`/perfil/${user.id}`}
                  icon={<RiUser3Line />}
                >
                  Meu Perfil
                </MenuItem>
                <MenuItem
                  as={Link}
                  to={`/perfil/${user.id}`}
                  icon={<RiShoppingBag3Line />}
                >
                  Meus Pedidos
                </MenuItem>
              </>)}

              <MenuItem
                onClick={() => {
                  setIsCategoryModalOpen(true);
                  menuDrawer.onClose();
                }}
                icon={<RiGridFill />}
              >
                Categorias
              </MenuItem>

              <Text
                px={5}
                pt={4}
                pb={1}
                fontSize="11px"
                fontWeight="800"
                color="gray.500"
                textTransform="uppercase"
              >
                Explorar
              </Text>

              <MenuItem
                onClick={handleScrollToStore}
                icon={<RiStore2Line />}
              >
                Bebidas
              </MenuItem>
              <MenuItem
                onClick={handleBestSellings}
                icon={<RiStarSmileLine />}
              >
                Destaques
              </MenuItem>
              <MenuItem
                as={Link}
                to="/quem_somos"
                icon={<RiInformationLine />}
              >
                Quem Somos
              </MenuItem>
              <MenuItem
                as="a"
                href="https://instagram.com/boozenoficial"
                target="_blank"
                icon={<RiInstagramLine />}
              >
                Instagram
              </MenuItem>

              <Text
                px={5}
                pt={4}
                pb={1}
                fontSize="11px"
                fontWeight="800"
                color="gray.500"
                textTransform="uppercase"
              >
                Categorias
              </Text>

              {linksCategories.map((card, index) => (
                <MenuItem
                  key={index}
                  as={Link}
                  to={`/produtos?filter=${encodeURIComponent(card.params)}`}
                  onClick={menuDrawer.onClose}
                  icon={<RiRecordCircleLine />}
                >
                  {card.title}
                </MenuItem>
              ))}

            </VStack>
          </DrawerBody>

          <Box
            p={4}
            borderTop="1px solid"
            borderColor="gray.100"
            bg="gray.50"
          >
            {user ? (
              <Button
                w="100%"
                leftIcon={<RiLogoutBoxLine />}
                bg={primaryGreen}
                color={primaryOrange}
                fontWeight="900"
                borderRadius="999px"
                onClick={signOutUser}
                _hover={{ opacity: 0.9 }}
              >
                Sair
              </Button>
            ) : (
              <Button
                as={Link}
                to="/sign_in"
                w="100%"
                leftIcon={<RiLoginBoxLine />}
                bg={primaryGreen}
                color={primaryOrange}
                fontWeight="900"
                borderRadius="999px"
                onClick={menuDrawer.onClose}
                _hover={{ opacity: 0.9 }}
              >
                Entrar
              </Button>
            )}
          </Box>
        </DrawerContent>
      </Drawer>

      <Drawer placement="right" onClose={cartDrawer.onClose} isOpen={cartDrawer.isOpen}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader borderBottomWidth="1px" color={primaryGreen}>
            Meu Carrinho
            <DrawerCloseButton />
          </DrawerHeader>

          <DrawerBody p={0}>
            <CartComponent />
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Flex
        display={{ base: "flex", md: "none" }}
        position="fixed"
        bottom="0"
        left="0"
        right="0"
        zIndex="1000"
        bg="rgba(0,74,51,.95)"
        backdropFilter="blur(20px)"
        borderTop={`1px solid rgba(239, 146, 7, .28)`}
        boxShadow="0 -8px 40px rgba(0,0,0,.35)"
        justify="space-around"
        py="8px"
      >
        <Button
          as={Link}
          to="/"
          variant="ghost"
          color={primaryOrange}
          flexDir="column"
          h="60px"
          fontSize="13px"
          fontWeight="800"
          _hover={{ bg: "whiteAlpha.200" }}
        >
          <RiHome5Line size={28} />
          <Text mt="2px">Home</Text>
        </Button>

        <Button
          onClick={() => setIsCategoryModalOpen(true)}
          variant="ghost"
          color={primaryOrange}
          flexDir="column"
          h="60px"
          fontSize="13px"
          fontWeight="800"
          _hover={{ bg: "whiteAlpha.200" }}
        >
          <FaBeer size={28} />
          <Text mt="2px">Categorias</Text>
        </Button>

        <Button
          onClick={menuDrawer.onOpen}
          variant="ghost"
          color={primaryOrange}
          flexDir="column"
          h="60px"
          fontSize="13px"
          fontWeight="800"
          _hover={{ bg: "whiteAlpha.200" }}
        >
          <RiMenu2Fill size={28} />
          <Text mt="2px">Menu</Text>
        </Button>

        <Button
          onClick={cartDrawer.onOpen}
          variant="ghost"
          color={primaryOrange}
          flexDir="column"
          h="60px"
          fontSize="13px"
          fontWeight="800"
          position="relative"
          _hover={{ bg: "whiteAlpha.200" }}
        >
          <Box position="relative" display="inline-flex" alignItems="center" justifyContent="center">
            <Badge
              position="absolute"
              top="-10px"
              right="-5px"
              bg={primaryOrange}
              color={primaryGreen}
              borderRadius="999px"
              minW="18px"
              h="18px"
              fontSize="12px"
              fontWeight="900"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {cartItemsCounter}
            </Badge>

            <RiShoppingBasket2Line size={28} />
          </Box>
          <Text mt="2px">Carrinho</Text>
        </Button>
      </Flex>


      <Box
        h={{
          base: isScrolled ? "86px" : (isHomePage ? "0px" : "0px"),
          md: isScrolled ? "105px" : (isHomePage ? "0px" : "0px"),
        }}
      />
      {/* <Box
        h={{
          base: isHomePage && !isScrolled ? "0px" : "82px",
          md: isHomePage && !isScrolled ? "0px" : "105px",
        }}
      /> */}
    </>
  );
};

export default React.memo(Navbar);
